<template>
  <div>
    <v-layout
      v-if="recommendedContractors.length === 0"
      id="recommended-contractor-section"
      wrap
    >
      <v-flex xs12 style="margin-top: 60px; margin-bottom: 10px">
        <h1 style="margin-bottom: 10px">
          <recommended-contractors-title />
        </h1>
        <div> There aren't any contractors for this report. </div>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="recommendedContractors.length !== 0"
      id="recommended-contractor-section"
      wrap
    >
      <v-flex xs12 style="margin-top: 60px; margin-bottom: 10px">
        <h1 style="margin-bottom: 10px">
          <recommended-contractors-title />
        </h1>
        <p v-if="custom_statement">
          {{ company.attributes.settings.recommended_contractor_statement }}
        </p>
        <p v-else>
          For issues found during the inspection, you can get a repair estimate
          for any of these contractors.
        </p>
      </v-flex>
      <v-flex xs12>
        <report-recommended-contractor-type
          :key="contractorType.id"
          :contractorType="contractorType"
          v-for="contractorType in recommendedContractors"
          @getQuote="handleGetQuote"
        />
      </v-flex>
    </v-layout>
    <report-recommended-contractor-quote-modal
      v-if="currentContractor"
      :buyer="buyer"
      :contractor="currentContractor"
      :inspectionId="report.inspection_id"
      :reportId="report.id"
      @closed="handleModalClose"
      @submitted="handleSubmitted"
    />
  </div>
</template>

<script>
// logic
import { mapState, mapActions } from 'vuex'
import uniqueArray from '@/utils/uniqueArray'
// components
import ReportRecommendedContractorType from './ReportRecommendedContractorType'
import ReportRecommendedContractorQuoteModal from './ReportRecommendedContractorQuoteModal'
import RecommendedContractorsTitle from '../recommended_contractors/RecommendedContractorsTitle.vue'

export default {
  components: {
    ReportRecommendedContractorType,
    ReportRecommendedContractorQuoteModal,
    RecommendedContractorsTitle,
  },

  data: () => ({
    currentContractor: null,
  }),

  computed: {
    ...mapState('reports', [
      'company',
      'inspection',
      'observations',
      'report',
      'reportContractors',
      'recommendedContractors',
    ]),
    buyer() {
      if (!this.inspection) {
        return {}
      }

      return (this.inspection.buyers || [])[0]
    },
    custom_statement() {
      return (
        this.company &&
        this.company.attributes.settings.recommended_contractor_statement
      )
    },
  },

  methods: {
    ...mapActions('reports', ['fetchReportContractors']),
    async formatRecommendedContractors() {
      const presentContractorTypes = uniqueArray(
        this.observations
          .filter(
            (observation) =>
              !['limit', 'info'].includes(observation.attributes.comment_type)
          )
          .map((observation) => observation.attributes.recommendation_id)
          .filter((item) => item != null)
      )

      let recommendedContractors = []
      let recommendedContractorTypes = []

      const contractors = this.reportContractors
      if (contractors) {
        // builds a unique list of contractor types based on what was returned in the contractor results
        // ['roofing', 'plumber', 'etc'...]
        contractors.forEach((contractor) => {
          const contractorTypes =
            (contractor &&
              contractor.attributes &&
              contractor.attributes.contractor_types) ||
            []

          contractorTypes.forEach((type) => {
            if (!recommendedContractorTypes.includes(type)) {
              recommendedContractorTypes.push(type)
            }
          })
        })

        // returns a sorted list of contractor types
        recommendedContractorTypes = uniqueArray(
          recommendedContractorTypes.sort((a, b) => (a > b ? 1 : -1))
        )

        // builds an array of contractor recommendations grouped by type
        recommendedContractors = recommendedContractorTypes
          .map((type) => {
            const filteredContractors = contractors.filter((contractor) =>
              (contractor.attributes.contractor_types || []).includes(type)
            )

            // ensure we're only adding contractors that have recommendations specified
            if (!presentContractorTypes.includes(type)) {
              return null
            }

            return {
              id: type,
              name: type,
              contractors: filteredContractors,
            }
          })
          .filter((item) => item != null)

        // ensure that the sidebar can access recommended contractors to show the menu item if any are present
        this.$store.commit('reports/setValue', {
          key: 'recommendedContractors',
          value: recommendedContractors,
        })
      }
    },

    handleGetQuote({ contractor }) {
      this.currentContractor = contractor
    },

    handleModalClose() {
      this.currentContractor = null
    },

    async handleSubmitted(resp) {
      this.$toaster.notifySaved({ msg: 'This quote has been submitted' })
      await this.fetchReportContractors(this.report.id)
      await this.formatRecommendedContractors()
      this.currentContractor = null
    },
  },

  mounted() {
    this.formatRecommendedContractors()
  },
}
</script>

<style></style>
